<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 cover" :style="cover_image">
          <!-- <img src="@/assets/images/cover/default.webp" alt="cover"> -->
          <section>
            <h2>{{ outlet_name }}</h2>
            <p>{{ outlet_code }}</p>
            <address>{{ address }}</address>
            <div class="edit" @click="toggleShow" v-b-tooltip.hover.left="{ variant: 'success' }"
              title="Change Cover Image"><i class="nc-icon nc-camera-20"></i></div>
          </section>
        </div>
      </div>
      <my-upload field="img" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail" v-model="show" :width="1024" :height="500" :params="params"
        :headers="headers" :lang-ext="en" :noCircle="true" :url="uploadUrl"
        img-format="jpg"></my-upload>
      <div class="mt-5" v-if="imgDataUrl && this.$dev">
        <pre>{{ imgDataUrl }}</pre>
        <pre>{{ imgUrl }}</pre>
        <img :src="imgDataUrl" alt="Cover" class="img-fluid">
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import myUpload from 'vue-image-crop-upload/upload-2.vue'
  import axios from "@/axios";
  export default {
    components: {
      'my-upload': myUpload
    },
    data() {
      return {
        roles: new Set(),
        outlet_name: '',
        outlet_code: '',
        address: '',
        userHasOutlet: false,
        outlet: '',
        outletid: '',
        cover_image: {},
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        show: false,
        params: {
          name: 'cover_image',
          cover_image: '',
          outletid: '',
          outlet_name: '',
        },
        headers: {
          smail: '*_~',
        },
        imgDataUrl: '', // the datebase64 url of created image
        imgUrl: '',
        uploadUrl: '',
        en: {
          hint: 'Click or drag & drop the file to upload',
          loading: 'Uploading…',
          noSupported: 'Browser is not supported, please use IE10+ or other browsers',
          success: 'Upload success!',
          fail: 'Upload failed!',
          preview: 'Preview',
          btn: {
            off: 'Cancel',
            close: 'Close',
            back: 'Back',
            save: 'Save'
          },
          error: {
            onlyImg: 'Image only',
            outOfSize: 'Image exceeds size limit: ',
            lowestPx: "Image's size is too low. Expected at least: "
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.prevRoute = from;
            console.log("prevRoute", vm.prevRoute);
            if (vm.prevRoute.name === "login") {
                // console.log("User", vm.user);
                /**
                 * Teporarily store value in local storage
                 * @val bool
                 */
                if (vm.user.role === "User") {
                    localStorage.setItem("isUser", true);
                }
                setTimeout(() => {
                  vm.$notifications.notify({
                      message: 'Refreshing Data, Please wait...',
                      icon: 'nc-icon nc-time-alarm',
                          horizontalAlign: 'right',
                          verticalAlign: 'top',
                          type: 'success'
                  });
                }, 1000);
                setTimeout(() => {
                    location.reload();
                }, 2000);
            }
        });
    },
    computed: {
      ...mapGetters(["user"]),
    },
    created() {
      console.log('User', this.user.roles);
      this.user.roles.forEach((r) => {
        this.roles.add(r.name);
      });
      this.user.outlet.forEach((outlet) => {
        if (outlet) {
          console.log('outlet', outlet);
          this.userHasOutlet = true;
          this.outlet = outlet;
          this.outletid = outlet.outletid;
        }
      });

      let accessToken = localStorage.getItem("token");
      if (accessToken && accessToken !== "") {
          this.headers.Authorization = `Bearer ${accessToken}`;
          // this.headers['Content-Type'] = 'multipart/form-data';
      }
      this.uploadUrl = process.env.NODE_ENV === "development"
            ? "http://localhost:8000/api/v1/outlet/cover/update"
            : "https://menu-api.tpdb.in/api/v1/outlet/cover/update"
    },
    mounted() {
      console.log('superadmin?', this.roles.has('superadmin'));
      console.log('user?', this.roles.has('user'));
      if (this.roles.has('superadmin')) {
        this.outlet_name = 'eMenu Dashboard';
        this.outlet_code = 'Welcome to eMenu, Manage all eMenu Users, Category, & Items';
        this.address = 'Indiranagar Bengaluru';
      }
      if (this.roles.has('user') && this.userHasOutlet) {
        this.user.outlet.forEach((outlet) => {
          this.outlet_name = this.outlet.name;
          this.outlet_code = 'Outlet Code: ' + this.outlet.outlet_code;
          this.address = this.outlet.address;
          this.params.outletid = this.outlet.outletid;
          this.params.outlet_name = this.outlet.name;
        });
      }
      this.getOutlet();
    },
    methods: {
      getOutlet() {
        if (this.roles.has('user')) {
          console.log('outletLog', this.outlet);
          axios.post('outlet/getById', {
          outletid: this.params.outletid
        }).then((res) => {
          console.log('outlet response', res.data.data);
          let outlet = res.data.data;
          if (outlet.cover_image !=="") {
            this.cover_image = {
            backgroundImage: "url(" + outlet.cover_image + ")"
          };
          } else {
            this.cover_image = {
              backgroundImage: "url(" + require('@/assets/images/cover/default.webp') + ")"
            }
          }
        });
        } else {
          this.cover_image = {
              backgroundImage: "url(" + require('@/assets/images/cover/default.webp') + ")"
            }
        }
      },
      toggleShow() {
        if (this.roles.has('superadmin')) {
          return this.$notifications.notify({
            message: 'Only user roles can upload cover image!',
            icon: 'nc-icon nc-notification-70',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger'
          })
        }
        this.show = !this.show
      },
      cropSuccess(imgDataUrl, field) {
        console.log('-------- crop success --------')
        this.imgDataUrl = imgDataUrl
        console.log('Croped img', imgDataUrl);
        console.log('Croped img fields', field);
        this.params.cover_image = imgDataUrl;
        console.log('params', this.params);
      },
      cropUploadSuccess(jsonData, field) {
        console.log('-------- upload success --------')
        console.log('jsonData', jsonData)
        console.log('field: ' + field)
        this.$notifications.notify({
          message: jsonData.message,
            icon: 'nc-icon nc-camera-20',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success'
        });
        this.getOutlet();
        setTimeout(() => {
          this.show = false;
        }, 1000);
      },
      cropUploadFail(status, field) {
        console.log('-------- upload fail --------')
        console.log(status)
        console.log('field: ' + field)
      },

    },
  }
</script>
<style>
@import '../assets/css/image-crop-upload.css';
  .cover {
    width: 100%;
    height: 400px;
    position: relative;
    z-index: 0;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    color: #fff;
  }

  .cover::before {
    position: absolute;
    content: '';
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: 2;
  }

  .cover>section {
    position: relative;
    z-index: 3;
    color: #fff;
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .edit {
    position: absolute;
    top: 20px;
    right: 5px;
    padding: 5px 9px;
    border: 1px solid #c6c6c5;
    border-radius: 50%;
    transition: all 0.5s ease-in-out;
    cursor: pointer;
  }

  .edit:hover {
    color: #000;
    background: #ccc;
    transition: all 0.5s ease-in-out;
  }

  .edit:hover>i {
    color: #000;
  }
</style>